import {
  Box,
  Button,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ZPUSOBY_PLATBY from "../zpusobyPlatby";

export default function DepositInfoCard({
  periodaZalohy,
  depositHodnota,
  zpusobPlatby,
  isSmallUser,
  onChangeDeposit,
}) {
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));

  const periodaLabel =
    periodaZalohy === "M"
      ? "Měsíční záloha"
      : periodaZalohy === "Q"
        ? "Čtvrtletní záloha"
        : periodaZalohy === "R"
          ? "Roční záloha"
          : "Neurčená perioda zálohy";

  return (
    <Paper
      variant="outlined"
      sx={{
        p: { xs: 2, sm: 3 },
        mb: 2,
        bgcolor: "background.paper",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { md: "center" },
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        {/* INFO */}
        <Stack spacing={1}>
          <Typography variant={isSmUp ? "h5" : "h6"} fontWeight="bold">
            {periodaLabel}:
            <Typography
              component="span"
              variant={isSmUp ? "h5" : "h6"}
              sx={{ ml: 1 }}
            >
              {depositHodnota}&nbsp;Kč
            </Typography>
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Způsob platby:&nbsp;
            {ZPUSOBY_PLATBY[zpusobPlatby] || "-"}
          </Typography>
        </Stack>

        {/* ACTION BUTTONS */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          width={{ xs: "100%", sm: "auto" }}
          sx={{
            margin: {
              xs: 0,
              sm: "0 auto",
              md: 0, // or keep as "0 auto" if you want centering on md as well
            },
            justifyContent: {
              xs: "center",
              sm: "initial",
            },
          }}
        >
          <Button
            variant="contained"
            size="large"
            fullWidth={!isSmUp}
            onClick={onChangeDeposit}
            disabled={!isSmallUser}
          >
            Změna výše zálohy
          </Button>
        </Stack>
      </Box>
    </Paper>
  );
}
